module.exports = __webpack_public_path__ + "static/media/empty-state-tag.9d85b640.png";